import * as KatalMetrics from '@amzn/katal-metrics';
import KatalMetricsDriverArrayCollector from '@amzn/katal-metrics/lib/driver/KatalMetricsDriverArrayCollector';
import KatalMetricsDriverConsoleLogJson from '@amzn/katal-metrics/lib/driver/KatalMetricsDriverConsoleLogJson';
import KatalMetricsDriverSushi from '@amzn/katal-metrics-driver-sushi';
import { v4 as uuidv4 } from 'uuid';
// Only used for testing
export let testMetricsDriver;
// Unique id for everything that happens in the current loaded scope
export const pageSessionId = uuidv4();
export const DriverBehavior = {
    // Logs all metrics to testMetricsDriver which you can use to test that your metrics would be sent
    // For an example of using that, see the tests written for metrics.ts
    CollectForTests: 'CollectForTests',
    // Logs metrics to the console, this is the default fallback if none of these values are provided.
    LogToConsole: 'LogToConsole',
    // Sends metrics to the 'test' sushi eel endpoint
    PublishToTest: 'PublishToTest',
    // Sends metrics to the 'prod' sushi eel endpoint
    PublishToProd: 'PublishToProd',
};
export const defaultDriverBehavior = (environmentName) => {
    // TODO: These strings are taken from et-console-components.inferEnvironment; trying to avoid a circular dependency
    //  here, but I don't like hard-coding the strings
    switch (environmentName) {
        case 'prod':
            return DriverBehavior.PublishToProd;
        case 'staging':
            return DriverBehavior.PublishToTest;
        case 'test':
            return DriverBehavior.CollectForTests;
        default:
            return DriverBehavior.LogToConsole;
    }
};
// In the future, we may want to send these across to a logging endpoint, for now
// just log errors.
const metricsErrorConsoleHandler = (err) => console.error(err);
const makeDriver = (behavior) => {
    switch (behavior) {
        case DriverBehavior.CollectForTests:
            testMetricsDriver = new KatalMetricsDriverArrayCollector(metricsErrorConsoleHandler);
            return testMetricsDriver;
        case DriverBehavior.PublishToTest:
            return new KatalMetricsDriverSushi.Builder()
                .withDomainRealm('test', 'USAmazon')
                .withErrorHandler(metricsErrorConsoleHandler)
                .build();
        case DriverBehavior.PublishToProd:
            return new KatalMetricsDriverSushi.Builder()
                .withDomainRealm('prod', 'USAmazon')
                .withErrorHandler(metricsErrorConsoleHandler)
                .build();
        default:
        case DriverBehavior.LogToConsole:
            return new KatalMetricsDriverConsoleLogJson();
    }
};
export const makePublisher = (siteName, serviceName, driverBehavior) => {
    const initialMetricsContext = new KatalMetrics.Context.Builder()
        .withSite(siteName)
        .withServiceName(serviceName)
        .withRelatedMetrics(new KatalMetrics.Metric.String('PageSessionId', pageSessionId))
        .build();
    return new KatalMetrics.Publisher(makeDriver(driverBehavior), metricsErrorConsoleHandler, initialMetricsContext);
};
export const makePublisherWithDefaultDriver = (siteName, serviceName, environment) => {
    return makePublisher(siteName, serviceName, defaultDriverBehavior(environment));
};
//# sourceMappingURL=publisher.js.map